import { withRouter } from '@fuselab/ui-fabric/lib/withRouter';
import { connect, Dispatch } from 'react-redux';
import { Store } from '../../store';
import { App, AppActions, AppAttributes } from './app';

function mapStoreToAttributes(store: Store): AppAttributes {
  return {
    user: store.user
  };
}

function mapDispatchToActions(dispatch: Dispatch<Store>): AppActions {
  return { };
}

export default withRouter(connect(mapStoreToAttributes, mapDispatchToActions)(App));
